export default "__VITE_ASSET__CL08i0EE__"